import { makeStyles } from "@mui/styles";
import {
  SURVEY_COLORS,
  SURVEY_TYPOGRAPHY,
  SURVEY_SPACING,
  SURVEY_MIXINS,
} from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useTextBoxQuestionStyles = makeStyles(() => ({
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
  },
  questionText: {
    ...SURVEY_MIXINS.questionLabel,
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: `${SURVEY_SPACING.BORDER_RADIUS} !important`,
      position: "relative",
    },
    width: "100%",
    "& .MuiInputBase-input": {
      fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
      fontFamily: "Arial, sans-serif",
      fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
      color: SURVEY_COLORS.TEXT_PRIMARY,
      backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    },
    "& .MuiInputBase-input::placeholder": {
      fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
      fontFamily: "Arial, sans-serif",
      fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
      opacity: "0.6",
    },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:active": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
  },
  textFieldError: {
    width: "100%",
    "& .MuiInputBase-input": {
      fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
      fontFamily: "Arial, sans-serif",
      fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
      color: SURVEY_COLORS.TEXT_PRIMARY,
      backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
    },
    "& .MuiInputBase-input::placeholder": {
      fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
      fontFamily: "Arial, sans-serif",
      fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
      opacity: "0.6",
    },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:hover": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:focus": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& input:-webkit-autofill:active": {
      WebkitBoxShadow: `0 0 0 100px ${SURVEY_COLORS.BACKGROUND_WHITE} inset !important`,
      WebkitTextFillColor: `${SURVEY_COLORS.TEXT_PRIMARY} !important`,
    },
    "& .MuiOutlinedInput-root": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: SURVEY_COLORS.ERROR,
        borderWidth: "2px",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: SURVEY_COLORS.ERROR,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: SURVEY_COLORS.ERROR,
      },
    },
  },
}));
